import React, { FC } from 'react';

const LoadingDots: FC = () => {
    return (
        <div className="snippet">
            <div className="stage">
                <div className="dot-pulse" />
            </div>
        </div>
    );
};

export default LoadingDots;
